import { TForms } from "./types"
import "./styles.scss"
import { ContentSectionContainer, fetchRoute } from "@cakemail-org/ui-components-v2"
import { FormsContext } from "./context"
import { Route, Routes } from "react-router-dom"
import FormsListing from "./containers/listing"
import FormDetails from "./containers/details"
import { ERoutes } from "../../utils/url"

export default function Forms({ }: TForms) {

    return <ContentSectionContainer className="formsContainer">
        <FormsContext.Provider value={{}}>
            <Routes>

                <Route index path={fetchRoute({ route: ERoutes.forms })} element={<FormsListing />} />
                <Route path={fetchRoute({ route: ERoutes.formDetails })} element={<FormDetails />} />
                <Route path={fetchRoute({ route: ERoutes.formEdit })} element={<FormDetails />} />

                <Route index path={"/"} element={<FormsListing />} />
                <Route index path={"/:formId"} element={<FormDetails />} />
                <Route index path={"/:formId/edit"} element={<FormDetails />} />

            </Routes>
        </FormsContext.Provider>
    </ContentSectionContainer >
}   